module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Man In The Mirror: Solving The 24 Problems Men Face")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "p0015-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#p0013-Anch-1",
      "id": "conf"
    }
  }, [_vm._v("FOREWORD")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0015-02-1"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_c('b', [_vm._v("M")])]), _vm._v("irror, mirror on the wall, who’s the fairest of them all?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-02-2"
    }
  }, [_vm._v("What greater vanity can be expressed than that of the evil queen in "), _c('i', [_vm._v("Snow White")]), _vm._v("? The queen was obsessed with the desire to be the most beautiful woman in the land. She loved her mirror. She spoke to it with terms of endearment . . . until one day the mirror gave her an answer, and she didn’t know which she hated more, Snow White or the mirror that refused to lie.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-03-6"
    }
  }, [_vm._v("If a dog is a man’s best friend, perhaps his worst enemy is his mirror. Well, maybe his mirror isn’t really his worst enemy; it merely reflects the image of his most formidable opponent. What opponent is more dangerous than the one who knows our deepest, darkest secrets? What opponent is more lethal than the one who can probe our most vulnerable points?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-04-8"
    }
  }, [_vm._v("The man in the mirror is me. Ouch! I suppose I should have said, “The man in the mirror is "), _c('i', [_vm._v("I")]), _vm._v(".” But “I” or “me,” the message is the same. What I see in the mirror is what I get, like it or not. My mirror won’t lie to me either.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-05-10"
    }
  }, [_vm._v("Mirrors are marvelous contraptions. Since Narcissus fell in love with his own image while gazing at his reflection in a pond, the human race has been fascinated by mirrors. Mirrors are the friends of magicians, the enemies of aging movie stars. We have round mirrors and square mirrors, big mirrors and compact mirrors, bathroom mirrors and rearview mirrors.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-06-12"
    }
  }, [_vm._v("The mirror was tiny Alice’s magical vehicle through which she could pass into a land of enchantment. The mirror was the symbol for the apostle Paul of our dim understanding of the mysterious things of God: “For now we see in a mirror dimly, but then face to face. Now I know in part; then I shall know fully, even as I have been fully known” (1 Corinthians 13:12 ESV).")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-02-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("I am a Weight Watcher, a “lifetime member.” At a recent meeting, a fellow member finally arrived at his goal weight after shedding sixty pounds of fat. The group leader asked him to relate how he felt after his accomplishment. He replied, “Now, I am no longer embarrassed to look in store windows. I used to avoid glancing at the store windows as I walked down the street. Every time I looked in a window, instead of seeing the merchandise displayed inside, all I could see was the reflection of my obese body. I stopped looking. Now, after reaching my goal weight, I enjoy looking in store windows again.”")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-03-4"
    }
  }, [_vm._v("What do you see when you look in the mirror? I have a large stand-up mirror in my bedroom. I can’t imagine why I ever parted with my hard-earned money to purchase such a loathsome thing. I use it for golf. That’s right. In the privacy of my bedchamber, I swing a golf club and check my positions in the mirror. One thing is certain: It doesn’t look like Jack Nicklaus in there.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-04-7"
    }
  }, [_vm._v("The doggone mirror is insensitive. In fact, it’s downright brutal. It shows me every wart, every bump in my shirt (bottom first), and every blemish.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-05-10"
    }
  }, [_vm._v("Now Pat Morley comes along and wants a mirror that can reflect the soul. Fortunately for me and for those who read this book, Morley’s mirror is gentle and kind. It tells the truth, which is scary enough, but it does so with encouragement and wisdom.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-06-12"
    }
  }, [_vm._v("Several years ago, I wrote a biography of a man’s life. Two things stick in my mind from the experience of writing that book. The first is that I discovered from probing the details of another man’s life that any human life is a profound study in fascination. The unique experiences of any individual’s life are genuine fodder for a gripping novel.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-06-13"
    }
  }, [_vm._v("The second thing I discovered was this: I found myself wondering, in a fit of egomania, if anyone would ever be inclined to write a biography of "), _c('i', [_vm._v("my ")]), _vm._v("life. I decided that such an idea was sheer fantasy. I was convinced it would never happen.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-02-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("I was astonished to discover that someone actually did undertake to write my biography. It was Pat Morley. The title of my biography is "), _c('i', [_vm._v("The Man in the Mirror")]), _vm._v(". The irony is that Morley didn’t even know he was writing my life story. You may be equally astonished to discover that it is your biography as well. It amazes me that Morley can write so many biographies all in one book.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-03-4"
    }
  }, [_vm._v("I am a teacher. I am in the knowledge business. The Bible warns us that knowledge “puffs up,” whereas love “builds up” (1 Corinthians 8:1). Yet, at the same time, the Bible exhorts us to seek knowledge. Such knowledge, however, is not to be sought as an end in itself. My Bible reads, “Wisdom is the principal thing; therefore get wisdom. And in all your getting, get understanding” (Proverbs 4:7 NKJV).")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-04-8"
    }
  }, [_vm._v("The goal of knowledge is wisdom. The goal of wisdom is to lead a life that is pleasing to God. This book is a book that contains uncommon wisdom. It is stirring, disturbing, and abundantly encouraging, all at the same time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-05-10"
    }
  }, [_c('i', [_vm._v("The Man in the Mirror")]), _vm._v(" is a book written by a man’s man. It is a book written by a man, for men. While I was reading this book, the thought kept occurring to me, "), _c('i', [_vm._v("I can’t wait for my wife, Vesta, to read ")]), _c('i', [_vm._v("this book")]), _vm._v(". Vesta is a voracious reader. She reads more than I do. I get my best tips on what to read next from her (even with books of theology). ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-P-1"
    }
  }, [_vm._v("I want my wife to read this book, not because I think she needs to read this book. I’m the one who needed to read it. I want my wife to read this book because I know my wife will be thrilled to read it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-06-12"
    }
  }, [_vm._v("One last tip for you. If someone gives you this book or if you buy it yourself, be sure to read it. If you don’t read it, by all means destroy it before your wife gets hold of it. If the unthinkable happens — if you don’t read it and your wife does — then, my dear brother, you are in deep weeds.")]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "p0017-07-14"
    }
  }, [_vm._v("R. C. Sproul, Orlando, Florida ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbe32110","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter3.vue
// module id = 72
// module chunks = 0